import { Image as ChakraImage, ImageProps } from '@chakra-ui/image'
import * as React from 'react'

import { TColorKey } from '~theme/typings'
import { getColorValue } from '~theme/utils'
import { getRadiusValue, TRadius } from '~ui/styleGuide/radiuses'
import { shadows, TOuterShadow } from '~ui/styleGuide/shadows'
import { useTheme } from '~ui/theme/ThemeProvider'

type TChakraProps = Pick<
  ImageProps,
  'src' | 'alt' | 'objectFit' | 'opacity' | 'maxWidth' | 'maxHeight' | 'clipPath'
>

type TProps = NoChildren &
  TChakraProps & {
    /**
     * background color of the transparent image
     */
    bgColor?: TColorKey
    /**
     * key of radius,
     * or an object with separate key for each corner
     */
    radius?: TRadius
    /**
     * key of outer box shadows
     */
    shadow?: TOuterShadow
  }

/**
 * abstraction on top of Chakra’s Image component
 * renders Image from the src URL
 */
export const Image: React.FC<TProps> = ({ bgColor, radius, shadow, ...chakraProps }) => {
  const theme = useTheme()

  const shadowValue = shadow && shadows.outer[shadow]
  const radiusValue = radius && getRadiusValue(radius)
  const bgColorValue = bgColor && getColorValue(theme)(bgColor)

  return (
    <ChakraImage
      {...chakraProps}
      bgColor={bgColorValue}
      boxShadow={shadowValue}
      borderRadius={radiusValue}
    />
  )
}
